export default {"src":"/_next/static/image/public/images/ic_clinic_pin_white.274e7c8117b5ba67f3ae240dccc21040.svg","height":32,"width":33};